import { PasswordCheck } from 'iconsax-react'
import { Button } from '../../components/ui/button'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../components/ui/alert-dialog'
import { Input } from '../../components/ui/input'
import { Label } from '../../components/ui/label'
import { usePasswordChangeController } from './usePasswordChangeController'

export const PasswordChange = () => {
  const { errors, handleResetPassword, isPending, register } =
    usePasswordChangeController()

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <div className="flex h-11 w-full cursor-pointer items-center justify-center rounded-sm border-[1px]">
          <div className="flex items-center gap-2">
            <PasswordCheck size="20" />
            <p>Alterar senha</p>
          </div>
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <form onSubmit={handleResetPassword}>
          <AlertDialogHeader>
            <AlertDialogTitle>
              Preencha os campos abaixo para alterar a senha
            </AlertDialogTitle>
            <AlertDialogDescription>
              <Label htmlFor="password" className="text-sm font-bold">
                Senha nova*
                <Input
                  {...register('password')}
                  className="my-2 h-11 border-[1px] border-black04 font-medium placeholder:text-black04"
                  id="password"
                  type="password"
                  placeholder="Insira sua senha nova"
                />
                {errors.password?.message}
              </Label>
              <Label htmlFor="confirmPassword" className="text-sm font-bold">
                Confirmar senha nova*
                <Input
                  {...register('confirmPassword')}
                  className="mt-2 h-11 border-[1px] border-black04 font-medium placeholder:text-black04"
                  id="confirmPassword"
                  type="password"
                  placeholder="Confirme sua senha nova"
                />
                {errors.confirmPassword?.message}
              </Label>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex items-center">
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction asChild>
              <Button
                type="submit"
                disabled={isPending}
                className="my-4 bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
              >
                Alterar a senha
              </Button>
            </AlertDialogAction>
          </AlertDialogFooter>
        </form>
      </AlertDialogContent>
    </AlertDialog>
  )
}
